import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import classes from "./LEPreviewV2.scss";
import { connect } from "react-redux";

import { getAssessmentPreviewQuery } from "Assessments/modules/AssessmentQuery";
import { getAssessmentPreviewDetailsFromCache } from "Assessments/modules/AssessmentGraphqlHelpers";
import { graphql, compose } from "lib/apolloClient";
import withLoader from "UIComponents/GqlWithLoader";
import I18nHOC from "UIComponents/I18nHOC";
import UIModal from "UIComponents/UIModal";

import { getPlannerTemplateFromCache } from "modules/CommonGraphqlHelpers";
import { getPlannerTemplateQuery } from "modules/CommonQuery";

import { getElementValue } from "modules/ElementValueUtils";
import { getRethumbUrl, getArchivedText } from "Utils";
import { GetLESteps } from "Utils/GetLESteps";
import FieldComponent from "UnitPlans/components/IBcomponents/FieldComponent";
import LabelComponent from "UnitPlans/components/LabelComponent";
import {
  fontStyle,
  colors,
  PLACEHOLDER_SQUARE_IMAGE,
  PLACEHOLDER_SQUARE_IMAGE_COUNT,
} from "Constants";
import { CURRICULUM_TYPE_DP } from "Constants/stringConstants";
import { getLocalisedTemplate } from "UnitPlans/routes/UnitPlanDetails/routes/EditUnitPlan/routes/IBPlanner/modules/IBPlannerModule";
import {
  CloseOutlined,
  CollapseArrowsTwoOutlined,
  ExpandArrowsTwoOutlined,
} from "@toddle-edu/ds-icons";
import { IconButton, EmptyState, DSProvider } from "@toddle-edu/ds-web";
import { fontStyles, ProjectOverviewIllustration } from "@toddle-edu/ds-theme";
import {
  getShowAssessmentTool,
  filterFieldsBasedOnConfig,
  getIsEnabledLTITools,
} from "ClassRoom/modules/utils";
import {
  getUnitPlanFieldsFromAssessment,
  updateAssessmentTemplate,
  updateTemplateForLearningGoals,
  combineUnitPlanMultiFieldData,
  updateCustomLabelsForUBDLearningGoals,
  updateStepList,
} from "Assessments/modules/Utils";
import ACLStore from "lib/aclStore";

import { getScoreDetailsMemoize } from "ScoreCategories/modules/ScoreCategoriesModule";
import classNames from "classnames";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";
import {
  getSelectedAcademicYearId,
  getUserArchivalStatus,
} from "modules/CommonSelectors";
import { getSubFields } from "UnitPlans/components/LibraryCommonComponents/ResourceEdit/modules/Utils";

const FIELD_TYPE_SPECIFIC_PROPS = {
  FieldDropdown: {
    buttonStyle: {
      padding: 0,
    },
    applyDefaultStyles: false,
  },
};

const styleObj = {
  assessmentToolsConStyle: {
    maxWidth: "575px",
    overflowX: "hidden",
  },
  textViewcustomTextStyle: {
    ...fontStyle.medium,
    color: colors.textSubtle,
    fontSize: "1.4rem",
    lineHeight: 1.8,
  },
  contentStyle: {
    ...fontStyle.medium,
    color: colors.textSubtle,
    fontSize: "1.4rem",
    lineHeight: 1.8,
  },
  labelContainerStyle: {
    marginBottom: 8,
  },
  studentTemplateCardStyle: {
    backgroundColor: colors.surfaceSubtle,
    borderRadius: "8px",
    border: `1px solid ${colors.surfaceSubtle}`,
  },
  resourceContainerStyle: {
    height: "48px",
    backgroundColor: colors.surfaceSubtle,
    borderRadius: "8px",
    border: `1px solid ${colors.surfaceSubtle}`,
  },
  horizontalAssessmentToolCardStyle: {
    height: "48px",
    backgroundColor: colors.surfaceSubtle,
    borderRadius: "8px",
    border: `1px solid ${colors.surfaceSubtle}`,
  },
  labelStyle: {
    ...fontStyle.demiBold,
    fontSize: "1.4rem",
    lineHeight: 2.0,
    color: colors.textDefault,
  },
  emptyStateStyles: {
    color: colors.textSubtle,
    fontWeight: fontStyles.regular,
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    padding: "0 34px",
  },
};

const isCheckValue = ({ value, fieldKey }) => {
  if (fieldKey == "voiceInstruction") {
    return !_.isEmpty(value);
  }
  return true;
};

const UpperCon = React.memo(
  ({
    t,
    LETitle,
    createdBy,
    imageURL,
    testId,
    id,
    onCloseClick,
    showCloseButton,
    showFullScreenButton,
    toggleFullscreenLE,
    isFullScreen,
    isFullScreenDisabled,
    customFullScreenUpperCon,
    headerLeftComp,
  }) => {
    const rethumpUrl = `url(${getRethumbUrl({
      width: 512,
      height: 384,
      imageUrl:
        imageURL ||
        PLACEHOLDER_SQUARE_IMAGE[id % PLACEHOLDER_SQUARE_IMAGE_COUNT],
      fitIn: true,
    })})`;

    const headerRightContainerClass = classNames({
      [classes.headerRightContainer]: true,
      [classes.fullScreenHeaderRightContainer]: isFullScreen,
    });

    const upperConClass = classNames({
      [classes.upperCon]: true,
      [classes.fullScreenUpperCon]: isFullScreen,
      [customFullScreenUpperCon]: !_.isEmpty(customFullScreenUpperCon),
    });

    const isStaffArchived = getUserArchivalStatus(createdBy);
    const formattedUserName = getFormattedUserName({
      user: createdBy,
      type: "staff",
    });
    const formattedCreatedBy = getArchivedText({
      name: formattedUserName,
      isArchived: isStaffArchived,
      t,
    });

    return (
      <div className={upperConClass}>
        {headerLeftComp ? (
          headerLeftComp
        ) : (
          <div className={classes.leftContainer}>
            <div
              className={classes.imageContainer}
              style={{
                backgroundImage: rethumpUrl,
              }}
            />
            <div className={classes.BFlexDivCol}>
              <div className={classes.leTitle}>{LETitle}</div>
              <div className={classes.createdByText}>
                {t("common:by_with_label", {
                  label: formattedCreatedBy,
                })}
              </div>
            </div>
          </div>
        )}
        <div className={headerRightContainerClass}>
          {showFullScreenButton && !isFullScreenDisabled && (
            <div
              data-test-id={`${testId}-toggleFullScreen`}
              className={classes.iconContainer}
              onClick={toggleFullscreenLE}
            >
              {isFullScreen ? (
                <IconButton
                  icon={<CollapseArrowsTwoOutlined variant="subtle" />}
                  size={"large"}
                  variant={"on"}
                />
              ) : (
                <IconButton
                  icon={<ExpandArrowsTwoOutlined variant="subtle" />}
                  size={"large"}
                  variant={"on"}
                />
              )}
            </div>
          )}
          {showCloseButton && showFullScreenButton && !isFullScreenDisabled && (
            <div className={classes.seperator}></div>
          )}
          {showCloseButton && (
            <IconButton
              icon={<CloseOutlined />}
              variant="plain"
              data-test-id={`${testId}-upperCon-close`}
              onClick={onCloseClick}
            />
          )}
        </div>
      </div>
    );
  }
);
UpperCon.displayName = "UpperCon";

const Fields = React.memo(
  ({
    t,
    fields,
    stepLabel,
    field_list,
    assessmentFields,
    unitPlanFields,
    assessmentId,
    portalType,
    attachmentItemHeight,
    assessmentDetails,
    currentAssessmentTypes,
  }) => {
    return _.map(fields, fieldKey => {
      const field = field_list[fieldKey] ? field_list[fieldKey] : {};
      if (_.includes(["title", "image", "assessmentCategory"], fieldKey)) {
        return null;
      }

      const {
        viewType,
        config: {
          viewLabel,
          label,
          styles,
          options,
          fieldTypeConfig = {},
          plannerElementConfig = {},
        } = {},
      } = field;
      const fieldData = _.find(assessmentFields, { uid: fieldKey });

      const unitPlanFieldValue = _.get(
        _.find(unitPlanFields, { uid: fieldKey }),
        "value",
        ""
      );

      const resolvedValue = _.get(fieldData, "resolvedMinimalTree", "") || {};
      let subjectIds = [];
      if (
        _.includes(
          [
            "benchmarks",
            "learningStandardUBD",
            "learningStandardMYP",
            "subjectStandardDP",
          ],
          fieldKey
        )
      ) {
        subjectIds = _.get(
          _.find(unitPlanFields, { uid: "subjects" }),
          "value",
          ""
        );
      }

      const assessmentFieldValue = _.get(fieldData, "value", "");

      const value = getElementValue({
        fieldUID: fieldKey,
        valueKeys: assessmentFieldValue,
        unitPlanFieldValue,
        fieldObj: field,
        subjectIds: subjectIds,
        resolvedValue: resolvedValue,
        t,
        currentAssessmentTypes,
      });

      const style = {
        ..._.get(styles, "style", {}),
        ..._.get(styles, "viewStyle", {}),
      };

      const checkValue = isCheckValue({
        value,
        fieldKey,
      });
      if (!checkValue) {
        return null;
      }
      const assessmentTools = _.get(assessmentDetails, "assessmentTools");

      // if step label and field label are same, do not show LabelComponent
      const isNotDuplicateLabel =
        !stepLabel ||
        (_.lowerCase(stepLabel) !== _.lowerCase(viewLabel) &&
          _.lowerCase(stepLabel) !== _.lowerCase(label));

      return (
        <div key={fieldKey} className={classes.item} style={style}>
          <DSProvider dsVersion={"1.0"}>
            <FieldComponent
              {...fieldTypeConfig}
              defaultOptions={options || []}
              textViewcustomTextStyle={styleObj.textViewcustomTextStyle}
              isApplyTextViewcustomTextStyle={true}
              contentStyle={styleObj.contentStyle}
              styles={{
                labelContainerStyle: {
                  marginBottom: 8,
                },
              }}
              studentTemplateCardStyle={styleObj.studentTemplateCardStyle}
              resourceContainerStyle={styleObj.resourceContainerStyle}
              horizontalAssessmentToolCardStyle={
                styleObj.horizontalAssessmentToolCardStyle
              }
              attachments={_.get(fieldData, "attachments", [])}
              type={viewType}
              mode={"view"}
              parentType={"ASSESSMENT"}
              parentId={assessmentId}
              label={viewLabel || label}
              labelComponent={
                isNotDuplicateLabel ? (
                  <LabelComponent
                    label={viewLabel || label}
                    labelStyle={{
                      ...fontStyle.demiBold,
                      fontSize: "1.4rem",
                      lineHeight: 1.71,
                      color: colors.blue400,
                    }}
                  />
                ) : null
              }
              value={value}
              fieldId={_.get(fieldData, "id", "")}
              fieldKey={fieldKey}
              portalType={portalType}
              attachmentItemHeight={attachmentItemHeight}
              isAssessmentToolPreview={true}
              assessmentToolsConStyle={styleObj.assessmentToolsConStyle}
              showAttachmentItemV3={true}
              isAssessmentCreationRevamp={true}
              assessmentTools={assessmentTools}
              field_list={field_list}
              assessmentFields={assessmentFields}
              unitPlanFields={unitPlanFields}
              {...(FIELD_TYPE_SPECIFIC_PROPS[viewType] || {})}
              plannerElementConfig={plannerElementConfig}
              subFields={getSubFields({
                fieldKey,
                fieldObj: field_list[fieldKey],
                unitPlanFields,
              })}
            />
          </DSProvider>
        </div>
      );
    });
  }
);

Fields.displayName = "Fields";

const Steps = React.memo(
  ({
    view_steps,
    step_list,
    field_list,
    assessmentFields,
    unitPlanFields,
    unitPlanAllFields,
    assessmentId,
    portalType,
    attachmentItemHeight,
    t,
    showAttachmentItemV3,
    assessmentDetails,
    isDPScoreV2,
    currentAssessmentTypes,
  }) => {
    const assessmentTools = _.get(assessmentDetails, "assessmentTools");

    const { isScoreEnabled } = getScoreDetailsMemoize({
      assessmentTools,
    });

    const someAssessmentToolsHasData = _.some(
      assessmentTools?.edges,
      ({ node }) => {
        const assessmentTool = _.get(node, "assessmentToolItem", {});
        const assessmentToolType = _.get(node, "assessmentToolType", "");

        const isTeacherEvaluationEnable = _.get(
          node,
          "isTeacherEvaluationEnable",
          false
        );
        const isStudentEvaluationEnable = _.get(
          node,
          "isStudentEvaluationEnable",
          false
        );

        return (
          getShowAssessmentTool({
            assessmentTool,
            assessmentToolType,
            allFields: assessmentFields,
          }) &&
          (isTeacherEvaluationEnable || isStudentEvaluationEnable)
        );
      }
    );

    return _.map(view_steps, key => {
      const { label, fields, subtext, viewSubtext } = step_list[key] || {};

      if (
        (isDPScoreV2 && _.includes(fields, "score") && !isScoreEnabled) ||
        (_.includes(fields, "measureAssessing") &&
          !someAssessmentToolsHasData &&
          _.includes(fields, "score") &&
          !isScoreEnabled)
      ) {
        return;
      }

      return (
        <div key={key} className={classes.stepContainer}>
          {label ? (
            <div className={classes.stepLabel}>
              {label}
              {(subtext || viewSubtext) && (
                <div className={classes.stepSubText}>
                  {viewSubtext ?? subtext}
                </div>
              )}
            </div>
          ) : null}
          <div className={classes.formContainer}>
            <Fields
              t={t}
              fields={fields}
              stepLabel={label}
              field_list={field_list}
              assessmentFields={assessmentFields}
              unitPlanFields={unitPlanFields}
              unitPlanAllFields={unitPlanAllFields}
              assessmentId={assessmentId}
              portalType={portalType}
              attachmentItemHeight={attachmentItemHeight}
              showAttachmentItemV3={showAttachmentItemV3}
              assessmentDetails={assessmentDetails}
              currentAssessmentTypes={currentAssessmentTypes}
            />
          </div>
        </div>
      );
    });
  }
);

Steps.displayName = "Steps";

const LEPreviewV2 = React.memo(
  ({
    testId,
    step_list,
    view_steps,
    field_list,
    assessmentDetails,
    assessmentFields,
    unitPlanFields,
    unitPlanAllFields,
    assessmentId,
    portalType,
    attachmentItemHeight,
    t,
    showAttachmentItemV3,
    showCloseButton = false,
    onCloseClick,
    getCurrentAssessmentTypes,
    wrapperStyle,
    isDPScoreV2,
    toggleFullscreenLE,
    isFullScreenLE,
    showFullScreenButton,
    showEmptyState,
    customFullScreenUpperCon,
    headerLeftComp = null,
    showHeader,
    handleClose,
  }) => {
    const currentAssessmentTypes = getCurrentAssessmentTypes();

    const {
      createdBy,
      title: { value: LETitle },
      image: { value: imageURL },
      id,
    } = assessmentDetails;

    const containerClass = classNames({
      [classes.container]: true,
      [classes.fullScreenContainer]: isFullScreenLE,
    });

    const wrapper = classNames({
      [classes.wrapper]: true,
      [classes.wrapperWithHeader]: showHeader,
      [classes.fullScreenWrapper]: isFullScreenLE,
    });

    const lowerConClass = classNames({
      [classes.lowerCon]: true,
      [classes.fullScreenLowerCon]: isFullScreenLE,
    });

    const lowerConClassWrapper = classNames({
      [classes.lowerConWrapper]: true,
      [classes.lowerConFullScreenWrapper]: isFullScreenLE,
    });

    const headerTextClass = classNames({
      ["heading-6"]: true,
      [classes.headerText]: true,
    });

    const getLEPreview = () => {
      const isViewStepsEmpty = _.isEmpty(view_steps);
      return (
        <div className={containerClass}>
          {showHeader ? (
            <div className={classes.header}>
              <div className={headerTextClass}>{t("common:preview")}</div>
              <IconButton
                icon={<CloseOutlined />}
                size={"medium"}
                _legacy_variant="plain"
                variant="neutral"
                type={"plain"}
                testId={`${testId}-close`}
                onClick={handleClose}
              />
            </div>
          ) : null}

          <div className={wrapper} style={wrapperStyle}>
            <UpperCon
              t={t}
              LETitle={LETitle}
              createdBy={createdBy}
              imageURL={imageURL}
              testId={testId}
              id={id}
              onCloseClick={onCloseClick}
              showCloseButton={showCloseButton}
              toggleFullscreenLE={toggleFullscreenLE}
              isFullScreen={isFullScreenLE}
              showFullScreenButton={showFullScreenButton}
              isFullScreenDisabled={isViewStepsEmpty}
              customFullScreenUpperCon={customFullScreenUpperCon}
              headerLeftComp={headerLeftComp}
            />
            <div className={lowerConClassWrapper}>
              {showEmptyState && isViewStepsEmpty ? (
                <EmptyState
                  illustration={ProjectOverviewIllustration}
                  title={t("common:empty_instructions_title_text")}
                  subtitle={t("common:empty_instructions_subtitle_text")}
                  subtitleStyle={styleObj.emptyStateStyles}
                />
              ) : (
                <div className={lowerConClass}>
                  <Steps
                    t={t}
                    view_steps={view_steps}
                    step_list={step_list}
                    field_list={field_list}
                    assessmentFields={assessmentFields}
                    unitPlanFields={unitPlanFields}
                    unitPlanAllFields={unitPlanAllFields}
                    assessmentId={assessmentId}
                    portalType={portalType}
                    attachmentItemHeight={attachmentItemHeight}
                    showAttachmentItemV3={showAttachmentItemV3}
                    assessmentDetails={assessmentDetails}
                    isDPScoreV2={isDPScoreV2}
                    currentAssessmentTypes={currentAssessmentTypes}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      );
    };

    const lePreviewComponent = getLEPreview();

    return isFullScreenLE ? (
      <UIModal isOpen={isFullScreenLE} isFullScreen={isFullScreenLE}>
        {lePreviewComponent}
      </UIModal>
    ) : (
      lePreviewComponent
    );
  }
);
LEPreviewV2.displayName = "LEPreviewV2";

const mapActionCreators = { getCurrentAssessmentTypes };

const mapStateToProps = state => {
  const userType = getUserInfo().user_type;
  const curriculumType = _.get(state, "platform.currentCurriculumProgram.type");
  const isDPScoreV2 =
    _.isEqual(curriculumType, CURRICULUM_TYPE_DP) &&
    ACLStore.can("FeatureFlag:DPScoreCategoriesV2");

  const academicYearId = getSelectedAcademicYearId(state);
  const userArchivedFilters = {
    academicYearId,
  };

  const collaboratorsFilter = {
    userAcademicYearId: academicYearId,
  };

  return {
    userType,
    isDPScoreV2,
    isData: true,
    isLoading: false,
    assessmentType: _.get(state, "assessment.filters.groupType", ""),
    curriculumType,
    plannerElementSets: _.get(state, "platform.currentPlannerElementSets", []),
    userArchivedFilters,
    collaboratorsFilter,
  };
};

const getDynamicTemplate = ({
  template,
  assessmentFields,
  t,
  userType,
  templateId,
  assessmentDetails,
  curriculumType,
  plannerElementSets,
}) => {
  const dynamicTemplate = updateTemplateForLearningGoals({
    template: _.cloneDeep(template),
    templateId,
  });

  const localisedTemplate = getLocalisedTemplate({
    template: { body: dynamicTemplate },
    t,
    templateType: "le",
  });

  if (!_.isEmpty(dynamicTemplate)) {
    const step_list = dynamicTemplate["step_list"];
    const field_list = dynamicTemplate["field_list"];

    if (_.includes(["UBD"], curriculumType) && !_.isEmpty(plannerElementSets)) {
      updateCustomLabelsForUBDLearningGoals({
        field_list,
        curriculumType,
        plannerElementSets,
        t,
      });
    }

    const view_steps = _.get(dynamicTemplate, "view_steps", []);

    if (!_.isEmpty(view_steps)) {
      _.forEach(view_steps, step => {
        const stepFields = _.get(step_list, `${step}.fields`, []);
        const filteredStepFields = filterFieldsBasedOnConfig({
          fields: stepFields,
          field_list,
          userType,
        });

        if (step_list?.[step]?.fields) {
          step_list[step].fields = filteredStepFields;
        }
      });
    }

    if (!getIsEnabledLTITools()) {
      updateStepList({
        step_list,
        fieldsToRemove: ["ltiTemplate"],
      });
    }

    return updateAssessmentTemplate({
      t,
      template: dynamicTemplate,
      assessmentType: _.get(assessmentDetails, "assessmentType.value"),
      isFromClassroom: true,
      curriculumType,
      resourceFields: assessmentFields,
      mode: "view",
      plannerElementSets,
      templateId,
      userType,
      assessmentTools: _.get(assessmentDetails, "assessmentTools", []),
    });
  }
  return dynamicTemplate;
};

LEPreviewV2.propTypes = {
  parentType: PropTypes.string,
  testId: PropTypes.string,
};

LEPreviewV2.defaultProps = {
  testId: "appComponents",
  parentType: "UNIT_PLAN",
  isFullScreenLE: false,
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["unitPlanTemplate", "common"] }),
  graphql(getAssessmentPreviewQuery, {
    name: "getAssessmentPreview",
    options: ({
      assessmentId,
      portalType,
      userArchivedFilters,
      collaboratorsFilter,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: assessmentId,
        portalType,
        userArchivedFilters,
        collaboratorsFilter,
      },
    }),
    props({ getAssessmentPreview, ownProps: { isData, isLoading } }) {
      const assessmentDetails = getAssessmentPreviewDetailsFromCache(
        getAssessmentPreview.variables
      );
      const templateId = _.get(assessmentDetails, "templateId", null);
      const unitPlanTemplateId = _.get(
        assessmentDetails,
        "unitPlan.templateId",
        null
      );

      return {
        assessmentDetails,
        unitPlanTemplateId,
        templateId,
        isData: !_.isEmpty(assessmentDetails) && isData,
        isLoading:
          getAssessmentPreview["networkStatus"] == 1 ||
          getAssessmentPreview["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getPlannerTemplateQuery, {
    name: "getPlannerTemplate",
    skip: ({ templateId }) => !templateId,
    options: ({ templateId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        ids: [templateId],
      },
    }),
    props({
      getPlannerTemplate,
      ownProps: {
        userType,
        isLoading,
        isData,
        templateId,
        assessmentDetails,
        parentType,
        curriculumType,
        t,
        plannerElementSets,
      },
    }) {
      const unitPlanFields = getUnitPlanFieldsFromAssessment({
        assessmentDetails,
      });

      const unitPlanAllFields = _.get(
        assessmentDetails,
        "unitPlan.allFields",
        []
      );
      const assessmentFields = _.get(assessmentDetails, "allFields", []);

      const templates = getPlannerTemplateFromCache(
        getPlannerTemplate.variables,
        true
      );
      const templateFromQuery = _.get(
        _.find(templates, { id: templateId }),
        "body",
        {}
      );

      const template = getDynamicTemplate({
        template: templateFromQuery,
        assessmentFields,
        t,
        userType,
        templateId,
        assessmentDetails,
        curriculumType,
        plannerElementSets,
      });

      const listSteps = GetLESteps({
        userType,
        template,
        resourceDetails: assessmentDetails,
        unitPlanFields,
        parentType,
      });

      return {
        step_list: listSteps.stepList,
        view_steps: listSteps.viewSteps,
        field_list: _.get(template, "field_list", {}),
        assessmentFields,
        unitPlanFields: combineUnitPlanMultiFieldData({
          templateBody: templateFromQuery,
          unitPlanFields: _.cloneDeep(unitPlanFields),
        }),
        isData: !_.isEmpty(templates) && isData,
        isLoading:
          getPlannerTemplate["networkStatus"] == 1 ||
          getPlannerTemplate["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  withLoader
)(LEPreviewV2);
